import { RegistroCta } from '@/features/auth/components/registro-cta';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { quickStartSteps } from '@/features/help-center/data/quick-start-steps';
import { DocsLayout } from '../components/docs-layout';

export function QuickStartPage() {
  return (
    <DocsLayout
      title="Guia Rapida"
      description="Comienza a usar Prixia en 5 pasos simples. De la configuracion a tu primera cotizacion en minutos."
    >
      <div className="space-y-8">
        {/* Steps */}
        <div className="relative pl-8 sm:pl-10 space-y-6">
          <div className="absolute left-[15px] top-4 bottom-4 w-0.5 bg-gray-200 dark:bg-gray-800 sm:left-[19px]" />

          {quickStartSteps.map((step, index) => {
            const isLast = index === quickStartSteps.length - 1;
            return (
              <div key={step.number} className={`relative ${isLast ? '' : 'pb-2'}`}>
                <div className="absolute -left-8 sm:-left-10 flex h-8 w-8 sm:h-10 sm:w-10 items-center justify-center rounded-full border-2 border-blue-500 bg-white dark:bg-gray-950 text-sm font-bold text-blue-600 sm:text-base">
                  {step.number}
                </div>

                <Card className="hover:shadow-md transition-shadow">
                  <CardContent className="p-5 sm:p-6">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                      {step.title}
                    </h3>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                      {step.description}
                    </p>

                    <ul className="mt-4 space-y-2">
                      {step.details.map((detail, dIdx) => (
                        <li
                          key={dIdx}
                          className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400"
                        >
                          <CheckCircle2 className="mt-0.5 h-4 w-4 text-emerald-500 shrink-0" />
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center py-12 px-6 rounded-2xl bg-gradient-to-r from-blue-50 to-violet-50 dark:from-blue-950/30 dark:to-violet-950/30 border border-blue-100 dark:border-blue-900/50">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Listo para empezar?</h2>
          <p className="mt-2 text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
            Crea tu cuenta gratuita y sigue estos pasos para tener tu equipo operando en minutos.
          </p>
          <RegistroCta
            className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-violet-600 px-6 py-3 rounded-lg hover:shadow-lg transition-shadow"
          >
            Crear Cuenta Gratis
            <ArrowRight className="w-4 h-4" />
          </RegistroCta>
        </div>
      </div>
    </DocsLayout>
  );
}
